<div class="trigger">
  <button class="btn btn-default" type="button" id="navegacao" (click)="toggleMenu()" accesskey="/">
    <span class="material-icons icon-28">&#xE5D2;</span>
  </button>
</div>
